import { EnvironmentStatusDot } from "@/components/environments/EnvironmentStatusDot";
import { useEnvironmentConversation, getAgentExecution } from "@/hooks/use-environment-conversation";
import { useEnvironmentName } from "@/hooks/use-environment-name";
import { useEnvironment } from "@/queries/environment-queries";
import { useProject } from "@/queries/project-queries";
import type { FC } from "react";

type EnvironmentContextBadgeProps = {
    environmentId: string;
};

export const EnvironmentContextBadge: FC<EnvironmentContextBadgeProps> = ({ environmentId }) => {
    const { data: environment } = useEnvironment(environmentId);
    const projectId = environment?.metadata?.projectId;
    const { data: project } = useProject(projectId);
    const { environmentConversation } = useEnvironmentConversation(environmentId);
    const agentExecution = getAgentExecution(environmentConversation) ?? undefined;
    const envName = useEnvironmentName(environment, agentExecution);

    if (!environment) {
        return null;
    }

    const projectName = project?.metadata?.name;

    return (
        <div className="flex items-center gap-1.5 px-4 pb-0 pt-2 text-xs text-content-muted">
            <EnvironmentStatusDot env={environment} size="sm" className="shrink-0" />
            {projectName && (
                <>
                    <span className="truncate">{projectName}</span>
                    <span>·</span>
                </>
            )}
            <span className="truncate">{envName}</span>
        </div>
    );
};
